const storagePrefix = "Bearer";

const storage = {
  getToken: () => {
    return JSON.parse(
      window.localStorage.getItem(`${storagePrefix}_token`) as string
    );
  },
  setToken: (token: string) => {
    window.localStorage.setItem(
      `${storagePrefix}_token`,
      JSON.stringify(token)
    );
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}_token`);
  },
  getCard: () => {
    const storedData = JSON.parse(
      window.localStorage.getItem(`${storagePrefix}_card`) as string
    );
    if (storedData) {
      const now = new Date().getTime();
      const isExpired = storedData.expiry < now;
      if (isExpired) {
        window.localStorage.removeItem(`${storagePrefix}_card`);
        return null;
      }
      return storedData.items;
    }
    return [];
  },
  setCard: (productId: string, quantity: number) => {
    const currentCart = storage.getCard() || [];
    const now = new Date().getTime();
    const expiry = now + 4 * 24 * 60 * 60 * 1000; // 4 days in milliseconds

    const existingProductIndex = currentCart.findIndex(
      (item: any) => item.productId === productId
    );

    if (existingProductIndex !== -1) {
      // If quantity is 0, remove the product from the cart
      if (quantity === 0) {
        currentCart.splice(existingProductIndex, 1);
      } else {
        currentCart[existingProductIndex].quantity = quantity;
      }
    } else {
      // Add the product if it doesn't exist in the cart
      if (quantity > 0) {
        currentCart.push({ productId, quantity });
      }
    }

    const updatedCart = { items: currentCart, expiry };
    window.localStorage.setItem(
      `${storagePrefix}_card`,
      JSON.stringify(updatedCart)
    );
  },

  deleteProduct: (productId: string) => {
    const currentCart = storage.getCard() || [];

    // Loop through the cart and apply the deletion logic
    const updatedCart = currentCart.reduce((acc: any[], item: any) => {
      // If the productId matches and quantity is 1, don't add it to the updatedCart
      console.log("====================================");
      console.log(item);
      console.log("====================================");
      if (item.productId === productId && item.quantity === 1) {
        return acc; // Skip this product (remove it)
      }
      // If the product's quantity is greater than 1, reduce the quantity by 1
      if (item.productId === productId && item.quantity > 1) {
        acc.push({ ...item, quantity: item.quantity - 1 });
        return acc;
      }
      // Add products that are not affected by the deletion
      if (item.quantity > 0) {
        acc.push(item);
      }
      return acc;
    }, []);

    const now = new Date().getTime();
    const expiry = now + 4 * 24 * 60 * 60 * 1000; // 4 days in milliseconds
    const newCart = { items: updatedCart, expiry };

    // Save the updated cart back to localStorage
    window.localStorage.setItem(
      `${storagePrefix}_card`,
      JSON.stringify(newCart)
    );
  },

  clearCard: () => {
    window.localStorage.removeItem(`${storagePrefix}_card`);
    window.localStorage.removeItem(`${storagePrefix}_orderCount`);
  },

  // Track order count
  setOrderCount: (count: number) => {
    window.localStorage.setItem(
      `${storagePrefix}_orderCount`,
      count.toString()
    );
  },

  getOrderCount: (): number => {
    const count = window.localStorage.getItem(`${storagePrefix}_orderCount`);
    return count ? parseInt(count) : 0;
  },

  clearOrderCount: () => {
    window.localStorage.removeItem(`${storagePrefix}_orderCount`);
  },
};

export default storage;
